// pages/index.js

import React, { useState, useEffect } from 'react';
import NameAvailability from './NameAvailability';
import { GET_SHORT_PROFILE } from 'helpers/graphql/profile';
import graphQLClient from 'helpers/graphQLClient';
import validateAccountName from 'helpers/validateAccountName';

export default function TfAvailability({ username }) {
  const [availability, setAvailability] = useState(null);

  const checTfAvailability = () => {
    if (validateAccountName(username)) return setAvailability(false);
    return graphQLClient(GET_SHORT_PROFILE, {
      username,
    })
      .then(({ profile }) => {
        if (profile) {
          setAvailability(false);
        } else {
          setAvailability(true);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (username) {
      checTfAvailability();
    }
  }, [username]);

  return (
    <div>
      <NameAvailability
        isAvailable={availability}
        name={username}
        platform="TravelFeed"
      />
    </div>
  );
}
